define("ember-svg-jar/inlined/campaign-add", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = _exports.default = {
    "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M.5 10.04V5.908c.22.089.46.138.711.138h.62v3.44l9.526 1.718v-7.55l-2.561.463a1.89 1.89 0 00-.51-1.261l3.071-.554V1.237a.666.666 0 111.332 0V13.62a.666.666 0 01-1.332 0v-1.064l-3.428-.618v1.49a2 2 0 01-4 0v-2.212l-2.098-.379v.497a.666.666 0 11-1.331 0v-1.293zm7.086-5.706a.711.711 0 01-.686.525H4.767v2.134a.711.711 0 11-1.423 0V4.86H1.211a.711.711 0 110-1.423h2.133V1.304a.711.711 0 011.423 0v2.133H6.9a.711.711 0 01.686.897zM5.26 11.456l1.337.241v1.732a.669.669 0 01-1.337 0v-1.973zm10.944-7.473a.666.666 0 10-.739-1.108l-1.714 1.143a.666.666 0 00.738 1.107l1.714-1.142zm-2.084 2.78a.666.666 0 000 1.331h1.714a.666.666 0 100-1.331H14.12zm-.554 3.153a.666.666 0 01.923-.184l1.714 1.143a.666.666 0 01-.738 1.107l-1.714-1.142a.666.666 0 01-.185-.924z\"/>",
    "attrs": {
      "width": "17",
      "height": "16",
      "viewBox": "0 0 17 16",
      "fill": "currentColor",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  };
});